import angular from 'angular';

class communityPortal {
    /*  @ngInject */

    constructor(
        $state,
        logger,
        CommunitySvc,
        SessionSvc,
        AuthSvc,
        $scope,
        $window,
        $translate,
        $stateParams,
        $uibModal,
        EMAIL_REGEXP
    ) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.CommunitySvc = CommunitySvc;
        this.SessionSvc = SessionSvc;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    refreshCommunity() {
        this.CommunitySvc.refreshCommunity(this.community.eid).then(data => {
            this.oldCommunity = data;
            this.community.managingOrders = this.oldCommunity.managingOrders;
            this.community.managingStockSoftware = this.oldCommunity.managingStockSoftware;
            this.community.managingReferential = this.oldCommunity.managingReferential;
            this.resetManagingSoftware = this.community.managingStockSoftware;
            this.resetUsingCga = this.community.usingCga;
            this.resetMandatoryCGVAcceptance = this.community.mandatoryCGVAcceptance;
            this.resetUsingLegalNotice = this.community.usingLegalNotice;
            this.workflowOrderEntry = !!this.oldCommunity.workflowOrderEntryRef;
            this.community.managingProductCatalog = this.oldCommunity.managingProductCatalog;

        });
    }

    $onInit() {
        this.oldCommunity = null;
        this.isAuthorized = this.SessionSvc.getCurrentUser().roles.includes('SUPPORT');
        this.isAuthorisedCPT = this.AuthSvc.isAuthorized('CONFIGURATOR');
        this.refreshCommunity();

        var defaultCellTemplate =
            '<div class="grid-cell-link text-center"> <div ng-click="grid.appScope.$ctrl.getCgaZip(row.entity.id)">{{COL_FIELD CUSTOM_FILTERS}}' +
            '<i class="fa fa-download"></i></div></div>';

        // Tableau CGA
        this.cgaGridOptions = {
            columnDefs: [
                {
                    name: 'documentVersion',
                    displayName: 'Version',
                    width: '33%',
                    cellClass: 'justify-content-center',
                },
                {
                    name: 'creationDate',
                    displayName: 'Date de la version',
                    width: '33%',
                    cellClass: 'justify-content-center',
                },
                {
                    name: 'documentId',
                    displayName: 'Télécharger',
                    cellTemplate: defaultCellTemplate,
                    width: '33%',
                    cellClass: 'pointer justify-content-center',
                },
            ],
            exporterOlderExcelCompatibility: false,
            enableRowSelection: false,
            enableSelectAll: false,
            useExternalPagination: false,
            useExternalSorting: false,
            enableInfiniteScroll: false,
            enableGridMenu: false,
            enableHorizontalScrollbar: 0,
            enableVerticalScrollbar: 0,
            enableSorting: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
            },
            data: this.documentInfos,
        };

        this.CommunitySvc.getWkfOrderEntryReferences(this.community.eid).then(r => {
            this.wkfReferences = r;
            this.community.workflowOrderEntryRef = r[0];
        });

        this.workflowOrderEntry = !this.workflowOrderEntry && !!this.community.workflowOrderEntryRef;
        this.initParams(this.legalNotices);
    }

    getGridHeight() {
        var rowHeight = 30;
        return {
            height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 30 + 'px',
        };
    }

    addNewCGA() {
        this.$uibModal
            .open({
                component: 'modalCgaImportComponent',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    communityEid: () => this.community.eid,
                },
            })
            .closed.then(() => {
                this.CommunitySvc.getCgaInfos(this.community.eid).then(documentInfos => {
                    this.cgaGridOptions.data = documentInfos;
                    this.documentInfos = documentInfos;
                });
            });
    }

    getCgaZip(documentId) {
        this.CommunitySvc.getCgaZip(documentId).then(
            data => {
                this.logger.success('CGU téléchargé avec succès', data);
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }

    initParams(legalNotices) {
        this.resetLegalNotice = angular.copy(legalNotices);
    }

    resetBlocs() {
        this.legalNotices.communityIdentity = this.resetLegalNotice.communityIdentity;
        this.legalNotices.headOffice = this.resetLegalNotice.headOffice;
        this.legalNotices.email = this.resetLegalNotice.email;
        this.legalNotices.phone = this.resetLegalNotice.phone;
        this.legalNotices.website = this.resetLegalNotice.website;
        this.legalNotices.pubDirector = this.resetLegalNotice.pubDirector;
        this.legalNotices.designEdition = this.resetLegalNotice.designEdition;
        this.legalNotices.websiteHosting = this.resetLegalNotice.websiteHosting;
    }

    isDisabledLegalNotice() {
        return !(this.isAuthorisedCPT && this.community.usingLegalNotice);
    }

    checkIfLegalNoticeFormValid() {
        return (
            !this.form.$valid &&
            (this.form.$dirty || this.form.$submitted)
        );
    }

    cancel() {
        this.community.managingStockSoftware = angular.copy(this.resetManagingSoftware);
        this.community.usingCga = angular.copy(this.resetUsingCga);
        this.community.mandatoryCGVAcceptance = angular.copy(this.resetMandatoryCGVAcceptance);
        this.community.usingLegalNotice = angular.copy(this.resetUsingLegalNotice);
        this.resetBlocs();
        this.$window.history.back();
    }

    save() {
        if ((this.community.usingCga && this.documentInfos.length === 0)) {
            this.logger.error('Une version CGU est requise');
            this.form.$valid = false;
        } else if ((this.community.usingLegalNotice && this.checkIfLegalNoticeFormValid())) {
            this.form.$valid = false;
        } else {
            this.form.$valid = true;
        }

        if (this.form.$valid) {
            const currentWorkflowOrderEntryRef = this.community.workflowOrderEntryRef;
            this.community.workflowOrderEntryRef = this.workflowOrderEntry ? this.wkfReferences[0] : '';
            this.mandatoryCGVAcceptance = this.community.mandatoryCGVAcceptance;
            this.legalNotices.communityEid = this.community.eid;
            var promises = [];
            var p1 = this.CommunitySvc.updateCommunityPortal(this.community);
            promises.push(p1);

            if (this.community.usingLegalNotice) {
                var p2 = this.CommunitySvc.saveLegalNotices(this.legalNotices);
                promises.push(p2)
            }

            if (this.oldCommunity.managingProductCatalog && !this.community.managingProductCatalog) {
                var p3 = this.CommunitySvc.disableProductCatalogManagementForAllSubEntities(this.oldCommunity.id)
                promises.push(p3)
            }
            Promise.all(promises).then(data => {
                    if (this.oldCommunity.managingProductCatalog !== this.community.managingProductCatalog) {
                        this.refreshCommunity();
                    }
                    this.logger.success('success.update', data[0], null, {
                        entityName: 'Communauté',
                    });
                    this.CommunitySvc.initMenuCommunity(this.community.eid);
                    if (data.length > 1) {
                        this.legalNotices = data[1];
                        this.initParams(data[1]);
                    }
                }
            ).catch(
                error => this.logger.error('error.update', error)
            )
            this.community.workflowOrderEntryRef = currentWorkflowOrderEntryRef;
        }
    }

    onManagingOrderChange() {
        this.workflowOrderEntry = false;
        this.community.managingOrderResponse = false;
        this.community.managingDesAdv = false;
    }
}

angular.module('app.community').component('communityPortal', {
    templateUrl: require('./community-portal.html'),
    controller: communityPortal,
    bindings: {
        initMenuConsult: '<',
        community: '<',
        documentInfos: '<',
        legalNotices: '<',
    },
});
